export default {
  id: "gaokao-application-guide",
  pride: 16384,
  slug: "gaokao-application-guide",
  series: "gaokao",
  category: "video",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "三分钟教会你填志愿【所有分段】",
    en: "How to Fill Gaokao Application in 3 Minutes [All Segments]"
  },
  bilibiliVideoId: "BV1tB4y147JR",
  descriptionKey: {
    zh: "高考完后到出分前全部投入志愿填报的亲身经验整理。",
    en: "Personal experience notes on Gaokao application — compiled during the wait between exam and results."
  },
  date: { year: 2022, month: 6, day: 17 },
  genres: ["实用指南", "志愿填报"],
  themes: ["高考", "志愿", "经验分享"],
  developerNotesKey: {
    zh: "高考完后到出分前全部投入志愿填报的亲身经验，能帮一个是一个！",
    en: "Personal experience from diving into application prep right after the exam. Hoping to help as many people as possible."
  },
  tags: ["高考"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1tB4y147JR/", textKey: { zh: "B站观看", en: "Watch on Bilibili" } }
  ]
};
